import Component from '@glimmer/component'
import { service } from '@ember/service'
import { on } from '@ember/modifier'
import type InteractivePreviewService from 'teacher-ui-client/services/interactive-preview'
import { BookPreview } from 'teacher-ui-client/interactive-preview/engines'
import type BookLibraryBook from 'teacher-ui-client/models/book-library/book'

interface Signature {
  Args: {
    book: BookLibraryBook
    buttonLabel: string
  }
}

export class BookLibraryReadBookLink extends Component<Signature> {
  @service interactivePreview!: InteractivePreviewService

  openBookPreview = () => {
    const preview = new BookPreview(this, this.interactivePreview.curriculum, this.args.book.code)
    this.interactivePreview.openPreview(preview, { title: this.args.book.title })
  }

  <template>
    <button
      data-test-read-book-link
      type="button"
      class="text-dusty-black-250 mt-2 text-base uppercase underline"
      {{on "click" this.openBookPreview}}
    >
      {{@buttonLabel}}
    </button>
  </template>
}

export default BookLibraryReadBookLink
